import { Box, Text } from '@acv/clearcar-component-lib';

export const ModalFooter = ({ text }) => (
  <Box justify="center">
    <Text>{text}</Text>
  </Box>
);
